'use client';

import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';

import type { SpacingType } from '@zoomit/primitives';
import { Flex } from '@zoomit/primitives';

type Props = {
  children: ReactNode;
  spacing?: SpacingType;
};

const MobileSlider = forwardRef<any, Props>((props, ref) => {
  const { children, spacing = { mt: 'x2', py: 'x2', px: 'x4' } } = props;
  return (
    <MobileArticleWrapper ref={ref} gap={1.6} flexWrap="nowrap" spacing={spacing}>
      {children}
    </MobileArticleWrapper>
  );
});

export default MobileSlider;

const MobileArticleWrapper = styled(Flex)`
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
`;
